import React from 'react';
import PropTypes from 'prop-types';
import {childrenType} from '../constants/proptype-validation';
import ControllableIFrameModalContainer from './common/ControllableIFrameModalContainer';

import '../assets/styles/app.scss';
import NotificationManagerWrapper from './common/NotificationManagerWrapper';

const BaseComponent = React.forwardRef(({children, disabled, isFFLoaded}, ref) => (
  <div className="isui-root-element" ref={ref}>
    {isFFLoaded &&
      (disabled ? (
        children
      ) : (
        <>
          <NotificationManagerWrapper>
            {children}
            <ControllableIFrameModalContainer />
          </NotificationManagerWrapper>
        </>
      ))}
  </div>
));

BaseComponent.propTypes = {
  children: childrenType.isRequired,
  isFFLoaded: PropTypes.bool.isRequired,
  disabled: PropTypes.bool
};

BaseComponent.displayName = 'BaseComponent';

export default BaseComponent;
